import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import * as moment from '@node_modules/moment-timezone';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { CreateRegistroRespostaPacienteClinicaDto, NotificacaoDto, NotificacaoServiceProxy, PacienteClinicaMedicaServiceProxy, ProfissionalSaudePacienteServiceProxy, RegistroRespostaPacienteClinicaServiceProxy } from '@shared/service-proxies/service-proxies';
import { finalize } from '@node_modules/rxjs/operators';

@Component({
  selector: 'app-view-notificacao-dialog',
  templateUrl: './view-notificacao-dialog.component.html',
  styleUrls: ['./view-notificacao-dialog.component.scss']
})
export class ViewNotificacaoDialogComponent extends AppComponentBase implements OnInit {

  notificacao: NotificacaoDto;
  protected tokenValido: boolean = false;
  constructor(
    injector: Injector,
    private readonly _pacienteClinicaMedicaService: PacienteClinicaMedicaServiceProxy,
    private readonly _profissionalPacienteService: ProfissionalSaudePacienteServiceProxy,
    private readonly _registroRespostaService: RegistroRespostaPacienteClinicaServiceProxy,
    private _cdr: ChangeDetectorRef,
    public bsModalRef: BsModalRef,
  ) {
    super(injector)
  }

  ngOnInit(): void {
    this.tokenValido = this.notificacao.token && moment(this.notificacao.terminoToken).isAfter(moment()) ? true : false;
  }

  protected createResposta(value: boolean): void {
    abp.ui.setBusy();
    const dto = new CreateRegistroRespostaPacienteClinicaDto({
      aceito: value,
      isClinica: this.notificacao.isClinica,
      notificacaoId: this.notificacao.id,
      pacienteId: this.notificacao.pacienteId,
      remetenteId: this.notificacao.remetenteId,
    });

    this._registroRespostaService.create(dto).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe(() => {
      this.notificacao.hasResposta = value;
      this._cdr.detectChanges();
    })
  }
}
